import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/events/annual-conference-attendees-list/AnnualConferenceAttendeesList.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/AnnualConferenceAttendeesList/components/SectionHeader'));
const SectionChart = dynamic(() => import('sections/Events/AnnualConferenceAttendeesList/components/SectionChart'));
const SectionCompanies = dynamic(() => import('sections/Events/AnnualConferenceAttendeesList/components/SectionCompanies'));

export default function AnnualConferenceAttendeesList() {
  return (
    <div className={cn('attendees')}>
      <SectionHeader />
      <SectionChart />
      <SectionCompanies />
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      path: '/events/annual-conference-attendees-list',
      title: 'View Attendees List for Annual Conference | DF Alliance',
      description: 'Check out the attendee list for DF Alliance\'s Annual Conference to connect with key stakeholders in the global freight forwarding and logistics industry.',
    },
  };
};

AnnualConferenceAttendeesList.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
